import React from "react";

import { inject, observer } from "mobx-react";

import { PermissionsController } from "../../PermissionsController";
import { Result } from "antd";
import { PermissionsList } from "./PermissionsList";

@inject("permissionsController")
@observer
export class PermissionsPanel extends React.Component<{
  permissionsController?: PermissionsController;
}> {
  public render() {
    const { selectedUserRole } = this.props.permissionsController;

    if (!selectedUserRole) {
      return (
        <Result
          title={"Please Select User Role to Manage Permissions"}
          //icon={<Icon type='lock' />}
        />
      );
    }

    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <PermissionsList />
      </div>
    );
  }
}
